import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const location = useLocation();

  console.log("ProtectedRoute Debug:", {
    isAuthenticated,
    user,
    adminOnly,
    isSuperuser: user?.is_superuser,
  });

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (adminOnly && !user?.is_superuser) {
    console.log("Redirecting to dashboard because user is not superuser");
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
